import { z } from 'zod';
import { SALES_ORDER_HEADER_CONSTRAINTS } from '../header-constraints.js';
// custom_fields.manifestNumber, deliberately camelCase (see merge-book-sales-order-custom-fields.ts).
export const manifestNumberSchema = z
    .string()
    .max(SALES_ORDER_HEADER_CONSTRAINTS.manifestNumber.maxLength, `${SALES_ORDER_HEADER_CONSTRAINTS.manifestNumber.label} must be ${SALES_ORDER_HEADER_CONSTRAINTS.manifestNumber.maxLength} characters or less.`)
    .optional()
    .nullable();
//# sourceMappingURL=manifest-number-schema.js.map